import { BrowserRouter, Route, Routes } from "react-router-dom";

import {
  CategoryPage,
  CreateCategoryPage,
  CreateFormPage,
  CreateLegislationPage,
  CreateNotificationPage,
  CreateOnboardingStepPage,
  CreatePackagePage,
  CreatePolicyPage,
  CreateRegistrationGroupPage,
  CreateSubcategoryPage,
  CreateTagPage,
  CreateUserPage,
  DashboardPage,
  FormPage,
  LegislationPage,
  LoginPage,
  NotificationPage,
  OnboardingStepsPage,
  PackagePage,
  PolicyPage,
  RegistrationGroupPage,
  ShowCategoryPage,
  ShowFormPage,
  ShowLegislationPage,
  ShowNotificationPage,
  ShowOnboardingStepPage,
  ShowPackagePage,
  ShowPolicyPage,
  ShowRegistrationGroupPage,
  ShowSubcategoryPage,
  ShowTagPage,
  ShowUserOnboardingProgressPage,
  ShowUserPage,
  SubcategoryPage,
  TagPage,
  UserOnboardingProgressPage,
  UserPage,
} from "../_modules";
import { Tickets } from "../_modules/Tickets";
import AuthRoutes from "./AuthRoutes";
import PrivateRoutes from "./PrivateRoutes";

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Private */}
        <Route element={<PrivateRoutes />}>
          <Route index path={"/dashboard"} element={<DashboardPage />} />
          {/* -------------------> PACKAGE <------------------- */}
          <Route index path={"/package"} element={<PackagePage />} />
          <Route
            index
            path={"/package/create"}
            element={<CreatePackagePage type="create" />}
          />
          <Route
            index
            path={"/package/edit"}
            element={<CreatePackagePage type="edit" />}
          />
          <Route index path={"/package/show"} element={<ShowPackagePage />} />
          {/* -------------------> PACKAGE <------------------- */}

          {/* -------------------> CATEGORY <------------------- */}
          <Route index path={"/category"} element={<CategoryPage />} />
          <Route
            index
            path={"/category/create"}
            element={<CreateCategoryPage type="create" />}
          />
          <Route
            index
            path={"/category/edit"}
            element={<CreateCategoryPage type="edit" />}
          />
          <Route index path={"/category/show"} element={<ShowCategoryPage />} />
          {/* -------------------> CATEGORY <------------------- */}

          {/* -------------------> SUB CATEGORY <------------------- */}
          <Route index path={"/subcategory"} element={<SubcategoryPage />} />
          <Route
            index
            path={"/subcategory/create"}
            element={<CreateSubcategoryPage type="create" />}
          />
          <Route
            index
            path={"/subcategory/edit"}
            element={<CreateSubcategoryPage type="edit" />}
          />
          <Route
            index
            path={"/subcategory/show"}
            element={<ShowSubcategoryPage />}
          />
          {/* -------------------> SUB CATEGORY <------------------- */}

          {/* -------------------> POLICY <------------------- */}
          <Route index path={"/policy"} element={<PolicyPage />} />
          <Route
            index
            path={"/policy/create"}
            element={<CreatePolicyPage type="create" />}
          />
          <Route
            index
            path={"/policy/edit"}
            element={<CreatePolicyPage type="edit" />}
          />
          <Route index path={"/policy/show"} element={<ShowPolicyPage />} />
          {/* -------------------> POLICY <------------------- */}

          {/* -------------------> LEGISLATION <------------------- */}
          <Route
            index
            path={"/legislation-link"}
            element={<LegislationPage />}
          />
          <Route
            index
            path={"/legislation-link/create"}
            element={<CreateLegislationPage type="create" />}
          />
          <Route
            index
            path={"/legislation-link/edit"}
            element={<CreateLegislationPage type="edit" />}
          />
          <Route
            index
            path={"/legislation-link/show"}
            element={<ShowLegislationPage />}
          />
          {/* -------------------> LEGISLATION <------------------- */}

          {/* -------------------> USER <------------------- */}
          <Route index path={"/user"} element={<UserPage />} />
          <Route
            index
            path={"/user/create"}
            element={<CreateUserPage type="create" />}
          />
          <Route
            index
            path={"/user/edit"}
            element={<CreateUserPage type="edit" />}
          />
          <Route index path={"/user/show"} element={<ShowUserPage />} />
          {/* -------------------> USER <------------------- */}

          {/* -------------------> TAG <------------------- */}
          <Route index path={"/tag"} element={<TagPage />} />
          <Route
            index
            path={"/tag/create"}
            element={<CreateTagPage type="create" />}
          />
          <Route
            index
            path={"/tag/edit"}
            element={<CreateTagPage type="edit" />}
          />
          <Route index path={"/tag/show"} element={<ShowTagPage />} />
          {/* -------------------> TAG <------------------- */}

          {/* -------------------> REGISTRATION GROUP <------------------- */}
          <Route
            index
            path={"/registration-group"}
            element={<RegistrationGroupPage />}
          />
          <Route
            index
            path={"/registration-group/create"}
            element={<CreateRegistrationGroupPage type="create" />}
          />
          <Route
            index
            path={"/registration-group/edit"}
            element={<CreateRegistrationGroupPage type="edit" />}
          />
          <Route
            index
            path={"/registration-group/show"}
            element={<ShowRegistrationGroupPage />}
          />
          {/* -------------------> REGISTRATION GROUP <------------------- */}

          {/* -------------------> FORM <------------------- */}
          <Route index path={"/form"} element={<FormPage />} />
          <Route
            index
            path={"/form/create"}
            element={<CreateFormPage type="create" />}
          />
          <Route
            index
            path={"/form/edit"}
            element={<CreateFormPage type="edit" />}
          />
          <Route index path={"/form/show"} element={<ShowFormPage />} />
          {/* -------------------> FORM <------------------- */}

          {/* -------------------> ONBOARDING STEPS <------------------- */}
          <Route
            index
            path={"/onboarding-step"}
            element={<OnboardingStepsPage />}
          />
          <Route
            index
            path={"/onboarding-step/create"}
            element={<CreateOnboardingStepPage type="create" />}
          />
          <Route
            index
            path={"/onboarding-step/edit"}
            element={<CreateOnboardingStepPage type="edit" />}
          />
          <Route
            index
            path={"/onboarding-step/show"}
            element={<ShowOnboardingStepPage />}
          />
          {/* -------------------> ONBOARDING STEPS <------------------- */}

          {/* -------------------> USER ONBOARDING PROGRESS <------------------- */}
          <Route
            index
            path={"/user-onboarding-progress"}
            element={<UserOnboardingProgressPage />}
          />
          <Route
            index
            path={"/user-onboarding-progress/show"}
            element={<ShowUserOnboardingProgressPage />}
          />
          {/* -------------------> USER ONBOARDING PROGRESS <------------------- */}

          {/* -------------------> Notification <------------------- */}
          <Route index path={"/notification"} element={<NotificationPage />} />
          <Route
            index
            path={"/notification/create"}
            element={<CreateNotificationPage type="create" />}
          />
          <Route
            index
            path={"/notification/edit"}
            element={<CreateNotificationPage type="edit" />}
          />
          <Route
            index
            path={"/notification/show"}
            element={<ShowNotificationPage />}
          />
          {/* -------------------> Notification <------------------- */}

          {/* -------------------> Tickets <------------------- */}
          <Route index path={"/tickets"} element={<Tickets />} />
          {/* -------------------> Tickets <------------------- */}
        </Route>

        {/* Auth */}
        <Route element={<AuthRoutes />}>
          <Route path={"/login"} element={<LoginPage />} />
          <Route path="*" element={<LoginPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
